export function deleteProperties(obj: object, props: string[]) {
	for (const key of props) {
		Reflect.deleteProperty(obj, key);
	}
	return obj;
}

declare global {
	interface Array<T> {
		first: () => T;
		update: (obj: Partial<T>, colName?: string, allowInsert?: boolean) => T[];
		groupBy: (key: string) => Record<string, T[]>;
		replaceByIndex: (index: number, value: T) => T[];
		toSort: (compareFn?: (a: T, b: T) => number) => T[];
	}
}

Array.prototype.first = function () {
	return this[0] ?? undefined;
};
Array.prototype.update = function (obj, colName, allowInsert = false) {
	const index = this.findIndex(t => t[colName ?? 'id'] === obj[colName ?? 'id']);
	if (index >= 0) return [...this.slice(0, index), { ...this[index], ...obj }, ...this.slice(index + 1)];
	if (allowInsert) return [...this, obj];
	return [...this];
};

Array.prototype.toSort = function (compareFn) {
	if (Array.prototype['toSorted']) return this.toSorted(compareFn);
	const sortedArray = [...this].sort(compareFn);
	return [...sortedArray];
};

Array.prototype.replaceByIndex = function (index, value) {
	if (Array.prototype['with']) return this.with(index, value);
	this[index] = value;
	return [...this];
};

Array.prototype.groupBy = function (key) {
	return this.reduce(function (rv, x) {
		(rv[x[key]] = rv[x[key]] || []).push(x);
		return rv;
	}, {});
};

export function toCamelCaseFields(object) {
	let newO, origKey, newKey, value;
	if (object instanceof Array) {
		return object.map(function (value) {
			if (typeof value === 'object') {
				value = toCamelCaseFields(value);
			}
			return value;
		});
	} else {
		newO = {};
		for (origKey in object) {
			// eslint-disable-next-line
			if (object.prototype.hasOwnProperty(origKey)) {
				newKey = (origKey.charAt(0).toLowerCase() + origKey.slice(1) || origKey).toString();
				value = object[origKey];
				if (value instanceof Array || (value !== null && value.constructor === Object)) {
					value = toCamelCaseFields(value);
				}
				newO[newKey] = value;
			}
		}
	}
	return newO;
}
